module.exports = __webpack_public_path__ + "static/media/image_s.52408941.png";